module.exports = __webpack_public_path__ + "img/hour.d4777cc3.svg";